import { createPinia } from 'pinia';

/** Root Pinia instance — injected at app boot and in Storybook decorators. */
const pinia = createPinia();

export default pinia;